import { IGeneric } from './types'
import http from '../../../http'
import { API_URL } from '../../../const'

const GENERICS_URL: string = `${API_URL}/Generics`

export const getGenerics = (pieceId: string) => http.get(`${GENERICS_URL}/${pieceId}`)

export const updateGenerics = (pieceId: string, data: IGeneric) =>
  http.put(`${GENERICS_URL}/${pieceId}`, { data })

export const publishGenerics = (pieceId: string) => http.post(`${GENERICS_URL}/publish/${pieceId}`)

export const unPublishGenerics = (pieceId: string) =>
  http.delete(`${GENERICS_URL}/unpublish/${pieceId}`)

export const deleteGenerics = (pieceId: string) => http.delete(`${GENERICS_URL}/${pieceId}`)

export const createGenerics = data => http.post(`${GENERICS_URL}`, { data })

export const getGenericsConfiguration = () => http.get(`${GENERICS_URL}/configuration`)

export const getProcessedDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/Produce/published/${level}`)

export const getSpecialDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/SpecialIngredient/published/${level}`)
